const runtimeConfig = window.__ENV__ || {};

const get = (key, fallback) =>
  runtimeConfig[key] || process.env[`REACT_APP_${key}`] || fallback;

export const CONFIG = {
    REACT_APP_BACKEND_URL: get("REACT_APP_BACKEND_URL", ""),
    REACT_APP_PROJECT_CLOSURE: get("REACT_APP_PROJECT_CLOSURE", ""),
    REACT_APP_IMPETUS: get("REACT_APP_IMPETUS", ""),
    REACT_APP_IMPETUS_DASHBOARD: get("REACT_APP_IMPETUS_DASHBOARD", ""),
    REACT_APP_PROCESS: get("REACT_APP_PROCESS", ""),
    REACT_APP_SGR: get("REACT_APP_SGR", ""),
    REACT_APP_CIR: get("REACT_APP_CIR", ""),
    REACT_APP_PACT: get("REACT_APP_PACT", ""),
};